import { LocationMenuData } from "..";

export function populateLegacyDefaults(menuData: LocationMenuData) {
    if (!menuData.currency) {
        menuData.locale = "en-AU";
        menuData.currency = "AUD";
    }
}
